import { render, staticRenderFns } from "./EquipmentRelationships.vue?vue&type=template&id=278a3b06&scoped=true&"
import script from "./EquipmentRelationships.vue?vue&type=script&lang=js&"
export * from "./EquipmentRelationships.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278a3b06",
  null
  
)

export default component.exports